import { Directive, DirectiveBinding } from 'vue';
import useMainStore from '@/composables/use-main-store';
import { REQUIRED_PRIVILEGES } from '@/constants/required-privileges';
import { PrivilegeService } from '@/services/privilege-service';
import { FeatureName } from '@/types/feature-name';
import { Privileges } from '@/types/privileges';

const PermissionDirective: Directive<HTMLElement, FeatureName> = (element: HTMLElement, binding: DirectiveBinding<FeatureName>): void => {
    const { roles, permissions } = useMainStore();

    const requiredPrivileges: Privileges = REQUIRED_PRIVILEGES[binding.value];
    const canAccess: boolean = PrivilegeService.canAccess(requiredPrivileges, roles.value, permissions.value);

    if (canAccess) {
        return;
    }

    element.remove();
};

export { PermissionDirective };
